<template>
  <div id="app">
    <h1>二维码生成工具</h1>
    <br />
    <qr />
    <h6>
      <a href="https://www.qqorw.com/">偶然网https://www.qqorw.com</a>
    </h6>
  </div>
</template>

<script>
import qr from "./components/qr";

export default {
  name: "App",
  components: {
    qr
  }
};
</script>

<style>
body {
  padding: 20px;
  font-family: "微软雅黑";
  font-weight: bold;
}
#app {
  text-align: center;
}
a {
  text-decoration: none;
}
a:hover {
  color: orange;
}
</style>



// WEBPACK FOOTER //
// src/App.vue